/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setAcdnMenu.js
 * 
 * アコーディオンメニュー
 * slideToggleモジュールと組み合わせてください。
 * 
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import { slideToggle, slideUp } from "./setSlideToggle";

var acdnToggle = document.querySelectorAll(".acdn-toggle");
var nodeAcdnToggle = Array.prototype.slice.call(acdnToggle, 0);

function setAcdnMenu() {
    nodeAcdnToggle.forEach(function (element) {
        element.addEventListener("click", () => {
            element.classList.toggle("is-active");
            slideToggle(element.nextElementSibling);
        });
    });
}

export { setAcdnMenu }